import { makeAutoObservable } from 'mobx';

import type { IPatientsStore } from '../Patients/store';
import type { IAppStore } from '../store';
import type { IPatientUserDetailsStore } from './PatientUserDetails/store';
import patientUserDetailsStore from './PatientUserDetails/store';

export enum FallRiskIndicators {
  'TUG' = 1,
  'STS' = 2,
  'FES' = 3,
  'Fall_History' = 4,
  'Fall_Questionnaire' = 5,
  'Gait_Analysis' = 6,
}

export interface IPatientDetailsStore {
  patientUserDetailsStore: IPatientUserDetailsStore;
}

export default class PatientDetailsStore implements IPatientDetailsStore {
  appStore: IAppStore;
  patientsStore: IPatientsStore;
  patientUserDetailsStore: IPatientUserDetailsStore;

  constructor(appStore: IAppStore, patientsStore: IPatientsStore) {
    makeAutoObservable(this);
    this.appStore = appStore;
    this.patientsStore = patientsStore;
    this.patientUserDetailsStore = new patientUserDetailsStore(
      this.patientsStore,
      appStore,
    ) as IPatientUserDetailsStore;
  }
}
